var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.isLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中...",
      "background-color": '#ffffff'
    }
  }) : _vm._e(), _c('main', [_vm.topImageUrl ? _c('img', {
    staticClass: "w-100",
    attrs: {
      "src": _vm.topImageUrl
    }
  }) : _vm._e(), _vm.branchSelectionIsEnabled ? _c('div', {
    staticClass: "p-3"
  }, [_c('p', {
    staticClass: "label-for-branch-selection"
  }, [_vm._v(_vm._s(_vm.deepGet(_vm.preorder, 'config.branch_select.default_select_text', '請選擇區域 / 櫃點')))]), _vm.branchSelectionPopulation === 'all' ? [_c('ShopSelection', {
    ref: "shopSelection",
    attrs: {
      "branch-provider": _vm.deepGet(_vm.preorder, 'config.branch_select.branch_provider'),
      "show-branch-code": _vm.deepGet(_vm.preorder, 'config.branch_select.show_branch_code', false),
      "placeholder": _vm.deepGet(_vm.preorder, 'config.branch_select.default_select_text', '請選擇區域 / 櫃點')
    },
    on: {
      "loading": _vm.handleBranchesAreLoading,
      "loaded": _vm.handleBranchesAreLoaded
    },
    model: {
      value: _vm.branchId,
      callback: function callback($$v) {
        _vm.branchId = $$v;
      },
      expression: "branchId"
    }
  })] : _vm._e(), _vm.branchSelectionPopulation === 'subset' ? [_c('ShopSubsetSelection', {
    ref: "shopSubsetSelection",
    attrs: {
      "branch-ids": _vm.deepGet(_vm.preorder, 'config.branch_select.branch_ids'),
      "show-parent-branches": _vm.deepGet(_vm.preorder, 'config.branch_select.show_parent_branch_options'),
      "show-branch-code": _vm.deepGet(_vm.preorder, 'config.branch_select.show_branch_code', false),
      "placeholder": _vm.deepGet(_vm.preorder, 'config.branch_select.default_select_text', '請選擇櫃點')
    },
    model: {
      value: _vm.branchId,
      callback: function callback($$v) {
        _vm.branchId = $$v;
      },
      expression: "branchId"
    }
  })] : _vm._e()], 2) : _vm._e(), _vm.bottomImageUrl ? _c('img', {
    staticClass: "w-100",
    attrs: {
      "src": _vm.bottomImageUrl
    }
  }) : _vm._e(), _c('footer', {
    staticClass: "footer-action-bar p-3"
  }, [_vm.terms !== null ? _c('div', {
    staticClass: "footer-action-bar__terms",
    domProps: {
      "innerHTML": _vm._s(_vm.terms)
    }
  }) : _vm._e(), _vm.hintForConsent !== null ? _c('label', {
    staticClass: "d-flex align-items-center justify-content-center mb-3"
  }, [_c('b-form-checkbox', {
    attrs: {
      "value": true,
      "unchecked-value": false
    },
    model: {
      value: _vm.hasConsentedToTerms,
      callback: function callback($$v) {
        _vm.hasConsentedToTerms = $$v;
      },
      expression: "hasConsentedToTerms"
    }
  }), _vm._v(" " + _vm._s(_vm.hintForConsent) + " ")], 1) : _vm._e(), _c('ShareButton', {
    staticClass: "footer-action-bar__button",
    attrs: {
      "variant": "primary",
      "disabled": _vm.hintForConsent !== null && false === _vm.hasConsentedToTerms || _vm.branchSelectionIsEnabled && _vm.branchId === null
    },
    on: {
      "click": _vm.handleNextStepButtonClicked
    }
  }, [_vm._v(" " + _vm._s(_vm.deepGet(_vm.preorder, 'config.welcome_page.button_text') || '下一步') + " ")])], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }